// test2461
(2461 && 0);
